// src/components/ErrorFallback.tsx
import React from "react";

const SentryErrorFallback: React.FC = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 bg-white px-4 text-center dark:bg-gray-900">
      <div className="mb-2 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
        <svg
          className="h-8 w-8 text-red-600 dark:text-red-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
        Oops! Something went wrong
      </h1>
      <p className="max-w-md text-gray-600 dark:text-gray-400">
        We've been notified of this error and our team is working on a fix.
        Please try refreshing the page.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="mt-4 rounded-lg bg-blue-600 px-6 py-2.5 font-medium text-white transition-colors hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600"
      >
        Refresh Page
      </button>
    </div>
  );
};

export default SentryErrorFallback;
